module.exports = __webpack_public_path__ + "assets/65a70cc4e39ae5b4a6fae388925eba01.png";